import { useEffect } from "react";
import consentManagerScript from "../../../utils/consentManagerScript";
import ShowConsentScript from "./ShowConsentScript";

const ConsentManager = () => {
  /**
   * 1)Check if we’re running in production:
   */
  const isProd = process.env.REACT_APP_RUN_ENV === "production";

  /**
   * 2) In production: read your CMP_ID from the .env (prefix must be REACT_APP_)
   */
  const CMP_ID = process.env.REACT_APP_DIA_CONSENT_MANAGER_ID || "";

  /**
   * 3) Always call useEffect (to satisfy the Rules of Hooks).
   *    Inside the effect, bail out if not in production.
   */
  useEffect(() => {
    if (!isProd) {
      // If we’re in development, do nothing.
      return;
    }
    // Only in production: inject the Consent Manager snippet into <head>.
    const scriptElement = document.createElement("script");
    scriptElement.textContent = consentManagerScript(CMP_ID);
    document.head.appendChild(scriptElement);

    return () => {
      document.head.removeChild(scriptElement);
    };
  }, [isProd, CMP_ID]);

  if (!isProd) {
    //Render nothing in development
    return null;
  }

  return (
    <ShowConsentScript />
  );
};

export default ConsentManager;
